import { Link } from 'react-router-dom';
import { featuredAnime } from '@/mocks/anime';

const animeImages = [
  'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20of%20a%20young%20warrior%20with%20a%20katana%20in%20a%20traditional%20Japanese%20setting%2C%20warm%20orange%20and%20red%20color%20palette%2C%20dynamic%20action%20pose%2C%20clean%20art%20style%2C%20soft%20gradient%20background%2C%20simple%20composition&width=400&height=560&seq=anime-featured-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20modern%20sorcerer%20in%20urban%20setting%20with%20purple%20energy%20effects%2C%20dynamic%20composition%2C%20warm%20coral%20accent%20colors%2C%20clean%20art%20style%2C%20soft%20gradient%20background%2C%20simple%20portrait&width=400&height=560&seq=anime-featured-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20an%20elf%20mage%20in%20a%20fantasy%20meadow%20with%20soft%20warm%20sunlight%2C%20gentle%20expression%2C%20flowing%20hair%2C%20pastel%20warm%20color%20palette%2C%20clean%20art%20style%2C%20simple%20background%2C%20peaceful%20atmosphere&width=400&height=560&seq=anime-featured-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20pop%20idol%20on%20stage%20with%20sparkling%20lights%2C%20bright%20warm%20stage%20lighting%2C%20dynamic%20performance%20pose%2C%20clean%20art%20style%2C%20simple%20gradient%20background%2C%20elegant%20composition&width=400&height=560&seq=anime-featured-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20illustration%20of%20a%20young%20cultivator%20in%20traditional%20Chinese%20robes%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20floating%20spiritual%20energy%2C%20clean%20art%20style%2C%20simple%20gradient%20background&width=400&height=560&seq=anime-featured-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20illustration%20of%20a%20powerful%20martial%20artist%20in%20ancient%20Chinese%20fantasy%20world%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20epic%20atmosphere%2C%20clean%20art%20style%2C%20simple%20gradient%20background&width=400&height=560&seq=anime-featured-06&orientation=portrait',
];

export default function FeaturedSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩番剧</p>
        </div>
        <Link
          to="/category"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
        {featuredAnime.map((anime, index) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group cursor-pointer"
          >
            <div className="relative w-full aspect-[5/7] rounded-lg overflow-hidden bg-background-200 mb-3">
              <img
                src={animeImages[index]}
                alt={anime.title}
                title={anime.title + ' - 奶片动漫高清播放'}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute top-2 left-2">
                <span className="px-2 py-0.5 bg-accent-500 text-white text-xs rounded-md font-medium whitespace-nowrap">
                  {anime.rating}
                </span>
              </div>
              {anime.status === '连载中' && (
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium whitespace-nowrap">
                    连载
                  </span>
                </div>
              )}
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
              {anime.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">
              {anime.category} · {anime.episodes}集
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}